'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeisAccountBalance = exports.getAccountForPersonId = exports.getBalancesForAccount = exports.getMyCompetitorsForFeis = exports.getDependentsForAccount = exports.getPaymentsForAccount = exports.getFeiseannaForAccount = exports.getMyFeiseanna = exports.getMyFeiseannaRelationships = exports.personIsLoading = undefined;

var _immutable = require('immutable');

var _paths = require('../feiseanna/paths');

var personIsLoading = exports.personIsLoading = function personIsLoading(state, pid) {
  return state.getIn(['persons', 'one', pid, 'loading']);
};

var getMyFeiseannaRelationships = exports.getMyFeiseannaRelationships = function getMyFeiseannaRelationships(state, aid) {
  return state.getIn(['accounts', aid, 'feiseanna']) || (0, _immutable.Map)();
};

var getMyFeiseanna = exports.getMyFeiseanna = function getMyFeiseanna(state, aid) {
  return getMyFeiseannaRelationships(state, aid).map(function (feis, feis_id) {
    return feis.setIn(['feis'], (0, _paths.getFeis)(state, feis_id));
  }).valueSeq();
};

var getFeiseannaForAccount = exports.getFeiseannaForAccount = function getFeiseannaForAccount(state, aid) {
  return state.getIn(['accounts', aid, 'feiseanna']) || (0, _immutable.List)();
};

var getPaymentsForAccount = exports.getPaymentsForAccount = function getPaymentsForAccount(state, aid) {
  return state.getIn(['accounts', aid, 'payments']) || (0, _immutable.List)();
};

var getDependentsForAccount = exports.getDependentsForAccount = function getDependentsForAccount(state, aid) {
  return state.getIn(['accounts', aid, 'dependents']) || (0, _immutable.List)();
};

var getMyCompetitorsForFeis = exports.getMyCompetitorsForFeis = function getMyCompetitorsForFeis(state, aid, fid) {
  return state.getIn(['accounts', aid, 'competitors', fid]) || (0, _immutable.List)();
};

var getBalancesForAccount = exports.getBalancesForAccount = function getBalancesForAccount(state, aid) {
  return state.getIn(['accounts', aid, 'balances']) || (0, _immutable.List)();
};

var getAccountForPersonId = exports.getAccountForPersonId = function getAccountForPersonId(state, pid) {
  return state.getIn(['persons', 'one', pid, 'acct_id']);
};

var getFeisAccountBalance = exports.getFeisAccountBalance = function getFeisAccountBalance(state, aid, feisId) {
  return state.getIn(['accounts', aid, 'feiseanna', feisId, 'balance']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/accounts/paths.js
// module id = 64
// module chunks = 0